import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

export default function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Core authorization engine extracted from your original layout
  const fetchUser = useCallback(async () => {
    try {
      const resp = await fetch(process.env.REACT_APP_SESSION_USER_URL, {
        method: 'GET',
        credentials: 'include',
      });

      if (!resp.ok) {
        throw new Error(`HTTP error! status: ${resp.status}`);
      }

      const json = await resp.json();
      
      if (json && json.email) {
        setUser(json);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error("AuthProvider session sync failed:", error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  // Secure API Session Destructor 
  const logout = useCallback(async () => {
    setLoading(true);
    try {
      await fetch(process.env.REACT_APP_LOGOUT_URL, {
        method: 'POST', // or GET depending on your backend script handler
        credentials: 'include',
      });
    } catch (error) {
      console.error("Backend logout transmission failed:", error);
    } finally {
      setUser(null);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <AuthContext.Provider value={{ user, loading, logout, refreshUser: fetchUser }}>
      {children}
    </AuthContext.Provider>
  );
}

// Hook wrapper for easy context injection
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be called inside an <AuthProvider> wrapper.");
  }
  return context;
}